export default function RefreshIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.61328 10.9887H2.23828M2.23828 10.9887V14.3637M2.23828 10.9887L4.6248 13.3752C5.19936 13.9498 5.88147 14.4056 6.63217 14.7165C7.38287 15.0275 8.18747 15.1875 9.00002 15.1875C9.81258 15.1875 10.6172 15.0275 11.3679 14.7165C12.1186 14.4056 12.8007 13.9498 13.3752 13.3752M12.3868 7.01128H15.7618M15.7618 7.01128V3.63628M15.7618 7.01128L13.3752 4.62478C12.8007 4.05021 12.1186 3.59445 11.3679 3.2835C10.6172 2.97254 9.81258 2.8125 9.00002 2.8125C8.18747 2.8125 7.38287 2.97254 6.63217 3.2835C5.88147 3.59445 5.19936 4.05021 4.6248 4.62478"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
